export default __webpack_public_path__ + "static/media/frontpagebg3.609c396e.png";